export enum SNACKBAR_VARIANTS {
  DEFAULT = 'default',
  COMMON = 'common',
  PROGRESS = 'progress',
}

export enum ICON_SIZES {
  SMALL = 'small',
  BIG = 'big',
}
